import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Badge, BadgeText } from '../badge'
import { type CountBadgeProps } from './CountBadge.types'
import { formatCount } from './formatCount'

type Variant = NonNullable<CountBadgeProps['variant']>

const surfaceClasses: Record<Variant, string> = {
    alert: 'bg-status-critical',
    neutral: 'bg-action-default',
    warning: 'bg-status-warning',
}

// Ink goes on the label: the gluestack base style paints its own colour.
const inkClasses: Record<Variant, string> = {
    // Figma NotificationBadge uses Content/default here, not the tenant on-primary ink.
    alert: 'text-aos-text-default',
    neutral: 'text-aos-text-on-primary',
    // Yellow surface needs dark text for contrast (Figma NotificationBadge Status=warning).
    warning: 'text-aos-text-on-graphics',
}

export function CountBadge({ count, max = 99, variant = 'alert', className }: CountBadgeProps) {
    const label = formatCount(count, max)
    return (
        <Badge
            className={twMerge(
                'min-w-[1.25rem] h-5 px-1 py-0 rounded-full justify-center',
                surfaceClasses[variant],
                className,
            )}
        >
            <BadgeText
                className={twMerge(
                    'normal-case text-[0.75rem] leading-[1rem] font-regular text-center',
                    inkClasses[variant],
                )}
            >
                {label}
            </BadgeText>
        </Badge>
    )
}
